import { render, staticRenderFns } from "./FabricSelector.vue?vue&type=template&id=51cb0c85&scoped=true"
import script from "./FabricSelector.vue?vue&type=script&lang=ts"
export * from "./FabricSelector.vue?vue&type=script&lang=ts"
import style0 from "./FabricSelector.vue?vue&type=style&index=0&id=51cb0c85&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51cb0c85",
  null
  
)

export default component.exports